/* tg-vslider.js - galleria verticale della scheda prodotto (23/10/2026).
   Stesso comportamento dello slider di Estoublon: una foto alla volta che scorre in
   verticale, puntini a destra, nessuna freccia, giro continuo, scorrimento automatico
   ogni 3 s (fermo col mouse sopra, con la tastiera dentro e con "riduci animazioni"),
   trascinamento verticale. Si costruisce dalle miniature .product__thumb di
   sections/main-product.liquid, che restano nel markup e vengono solo nascoste
   (classe has-tgv, vedi tg-vslider.css). Su desktop tiene la lente di ingrandimento.
   Il video della bottiglia diventa l'ultima diapositiva e parte solo quando e' in vista. */
(function () {
  'use strict';
  var ZOOM = 2.3, DELAY = 3000, SPEED = 500, FLAG = 'has-tgv';

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) { for (var k in attrs) { e.setAttribute(k, attrs[k]); } }
    return e;
  }

  function build(gal) {
    if (gal.classList.contains(FLAG)) return;
    var en = /^en/i.test(document.documentElement.lang || '');
    var items = [], videoSrc = '';
    Array.prototype.forEach.call(gal.querySelectorAll('.product__thumb'), function (b) {
      if (b.classList.contains('product__thumb--video')) { videoSrc = b.getAttribute('data-video') || ''; return; }
      var full = b.getAttribute('data-full');
      if (full) items.push({ type: 'img', src: full, zoom: b.getAttribute('data-zoom') || full, alt: b.getAttribute('data-alt') || '' });
    });
    if (!items.length) {
      var mm = gal.querySelector('.product__main'), mi = mm && mm.querySelector('img');
      if (mi) items.push({ type: 'img', src: mi.currentSrc || mi.src, zoom: mm.getAttribute('data-zoom') || mi.src, alt: mi.alt || '' });
    }
    if (videoSrc) items.push({ type: 'video', src: videoSrc });
    if (!items.length) return;

    var n = items.length, multi = n > 1;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
    var hintEl = gal.querySelector('.product__zoomhint');
    var hintText = hintEl ? hintEl.textContent : '';

    function slide(item, i, clone) {
      var s = clone ? el('div', 'tgv__slide', { 'aria-hidden': 'true' })
                    : el('div', 'tgv__slide', { role: 'group', 'aria-roledescription': 'slide', 'aria-label': (i + 1) + ' / ' + n });
      var m;
      if (item.type === 'video') {
        m = el('video', 'tgv__media', { playsinline: '', muted: '', preload: 'metadata', 'aria-label': en ? 'Bottle video' : 'Video della bottiglia' });
        m.muted = true; m.loop = true; m.src = item.src;
      } else {
        m = el('img', 'tgv__media', { src: item.src, alt: clone ? '' : item.alt, draggable: 'false', decoding: 'async' });
        m.loading = (i === 0 && !clone) ? 'eager' : 'lazy';
      }
      s.appendChild(m);
      return s;
    }

    var wrap = el('div', 'tgv', { role: 'region', 'aria-roledescription': 'carousel', 'aria-label': en ? 'Product photos' : 'Foto del prodotto' });
    var list = el('div', 'tgv__list', { tabindex: '0' });
    var track = el('div', 'tgv__track');
    if (multi) track.appendChild(slide(items[n - 1], n - 1, true));
    items.forEach(function (it, i) { track.appendChild(slide(it, i, false)); });
    if (multi) track.appendChild(slide(items[0], 0, true));
    var lens = el('span', 'tgv__lens', { 'aria-hidden': 'true' });
    list.appendChild(track);
    list.appendChild(lens);
    if (fine && hintText) { var h = el('span', 'tgv__hint', { 'aria-hidden': 'true' }); h.textContent = hintText; list.appendChild(h); }
    wrap.appendChild(list);

    var idx = 0, pos = multi ? 1 : 0, H = 0, busy = false, drag = null;
    var timer = 0, settleT = 0, hover = false, visible = true, lensUrl = '';
    var dots = [];

    function go(i) { goTo(i); schedule(); }

    if (multi) {
      var dwrap = el('div', 'tgv__dots');
      items.forEach(function (it, i) {
        var d = el('button', 'tgv__dot', { type: 'button', 'aria-label': (en ? 'Photo ' : 'Foto ') + (i + 1) });
        d.appendChild(el('span'));
        d.addEventListener('click', function () { go(i); });
        dwrap.appendChild(d);
        dots.push(d);
      });
      wrap.appendChild(dwrap);
    }

    function slideAt(k) { return track.children[k + (multi ? 1 : 0)]; }
    function measure() { H = list.clientHeight; }
    function put(p, anim, extra) {
      track.style.transition = (anim && !reduce) ? 'transform ' + SPEED + 'ms ease' : 'none';
      track.style.transform = 'translate3d(0,' + (-p * H + (extra || 0)) + 'px,0)';
    }
    function mark() {
      dots.forEach(function (d, i) {
        if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      items.forEach(function (it, i) {
        if (it.type !== 'video') return;
        var v = slideAt(i).querySelector('video');
        if (!v) return;
        if (i === idx) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }
    function settle() {
      clearTimeout(settleT);
      if (pos === 0) pos = n; else if (pos === n + 1) pos = 1;
      put(pos, false);
      busy = false;
    }
    function goTo(i) {
      if (!multi || busy) return;
      busy = true;
      pos = i + 1;
      idx = ((i % n) + n) % n;
      list.classList.remove('zoom');
      mark();
      put(pos, true);
      clearTimeout(settleT);
      settleT = setTimeout(settle, reduce ? 0 : SPEED + 60);
    }
    function schedule() {
      clearTimeout(timer);
      if (!multi || reduce || hover || !visible || document.hidden || drag) return;
      timer = setTimeout(function () { goTo(idx + 1); schedule(); }, DELAY);
    }

    list.addEventListener('mouseenter', function () { hover = true; clearTimeout(timer); });
    list.addEventListener('mouseleave', function () { hover = false; schedule(); });
    wrap.addEventListener('focusin', function () { hover = true; clearTimeout(timer); });
    wrap.addEventListener('focusout', function () { hover = false; schedule(); });
    list.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });

    list.addEventListener('pointerdown', function (e) {
      if (!multi || busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
      drag = { y: e.clientY, dy: 0, id: e.pointerId };
      list.classList.add('is-drag');
      list.classList.remove('zoom');
      clearTimeout(timer);
      try { list.setPointerCapture(e.pointerId); } catch (x) {}
      put(pos, false);
    });
    list.addEventListener('pointermove', function (e) {
      if (drag) { if (e.pointerId === drag.id) { drag.dy = e.clientY - drag.y; put(pos, false, drag.dy); } return; }
      lensMove(e);
    });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dy = drag.dy;
      drag = null;
      list.classList.remove('is-drag');
      if (Math.abs(dy) > Math.max(40, H * 0.12)) { go(idx + (dy < 0 ? 1 : -1)); }
      else { put(pos, true); schedule(); }
    }
    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
    list.addEventListener('pointerleave', function () { list.classList.remove('zoom'); });

    function lensMove(e) {
      if (!fine || busy) return;
      var it = items[idx];
      if (it.type !== 'img') { list.classList.remove('zoom'); return; }
      var s = slideAt(idx), img = s && s.querySelector('img');
      if (!img || !img.naturalWidth) return;
      var r = list.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      var ratio = img.naturalWidth / img.naturalHeight, cw = r.width, ch = r.height, dw, dh;
      if (ratio > cw / ch) { dw = cw; dh = cw / ratio; } else { dh = ch; dw = ch * ratio; }
      var ix = x - (cw - dw) / 2, iy = y - (ch - dh) / 2;
      if (ix < 0 || iy < 0 || ix > dw || iy > dh) { list.classList.remove('zoom'); return; }
      if (lensUrl !== it.zoom) { lens.style.backgroundImage = 'url("' + it.zoom + '")'; lensUrl = it.zoom; }
      var lw = lens.offsetWidth, lh = lens.offsetHeight;
      lens.style.left = (x - lw / 2) + 'px';
      lens.style.top = (y - lh / 2) + 'px';
      lens.style.backgroundSize = (dw * ZOOM) + 'px ' + (dh * ZOOM) + 'px';
      lens.style.backgroundPosition = (-(ix * ZOOM - lw / 2)) + 'px ' + (-(iy * ZOOM - lh / 2)) + 'px';
      list.classList.add('zoom');
    }

    function relayout() { measure(); put(pos, false); }
    if (window.ResizeObserver) { new ResizeObserver(relayout).observe(list); } else { window.addEventListener('resize', relayout); }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) schedule(); else clearTimeout(timer);
      }, { threshold: 0.25 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', schedule);

    gal.insertBefore(wrap, gal.firstChild);
    gal.classList.add(FLAG);
    measure();
    put(pos, false);
    mark();
    schedule();
  }

  function init() {
    var g = document.querySelector('.product__gallery');
    if (g) build(g);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
